import { downloadPlaylistReport } from '@disco/state-management/actions/ReportActions'
import type { PlaylistReportState } from '@disco/state-management/reducers/reports/playlistReport'
import * as React from 'react'
import { connect } from 'react-redux'
import type { State } from 'types/redux'
import EllipsisMenu from 'components/ui/ellipsis-menu'

function mapStateToProps(state: State): any {
  return {
    playlistReport: state.reports.playlistReport,
  }
}

const mapDispatchToProps = {
  downloadPlaylistReport,
}
type ReportFormat = 'deferred_csv' | 'deferred_xlsx'
type Props = {
  playlistReport: PlaylistReportState
  downloadPlaylistReport: typeof downloadPlaylistReport
  disabled?: boolean
}

class ReportDownloadButton extends React.Component<Props> {
  _onExportClick = (format: ReportFormat) => {
    this.props.downloadPlaylistReport(format)
  }

  render() {
    const { generatedForCurrentParams } = this.props.playlistReport
    const { generating, results } = this.props.playlistReport.report
    let noResults = false

    if (
      generatedForCurrentParams &&
      results &&
      'data' in results &&
      results.data.rows.length === 0
    ) {
      noResults = true
    }

    return (
      <EllipsisMenu
        compact
        caption="Download report"
        disabled={generating || noResults || this.props.disabled}
        options={[
          // {
          //   label: 'Export to PDF',
          //   value: '',
          //   icon: 'pdf',
          //   disabled: true,
          // },
          {
            label: 'Export to Excel',
            value: 'deferred_xlsx',
            icon: 'spreadsheet',
          },
          {
            label: 'Export to CSV',
            value: 'deferred_csv',
            icon: 'csv',
          },
        ]}
        onOptionClick={this._onExportClick}
      />
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportDownloadButton) as any
